import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import createTheme from '@mui/material/styles/createTheme';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'assets/scss/app.scss';
import AppRoutes from 'routes';
import { theme } from '../../theme';
import { useApp } from './app-hooks';
import { appStyles as styles } from './styles';

import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import NewRelicInitializer from './newrelic';
import SiteStatusPage from 'pages/site-status-page/site-status-page';

const App = () => {
  const {
    customerDetailLoading,
    isAppLoading,
    setIsAppLoading,
    isVerifyTokenLoading,
    isCheckTokenLoading,
    queryClient,
    clientPublicInfo,
  } = useApp();

  if (document.readyState === 'complete' && isAppLoading) {
    setIsAppLoading(false);
  } else {
    const onLoad = () => {
      setIsAppLoading(false);
      window.removeEventListener('load', onLoad);
    };
    window.addEventListener('load', onLoad);
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <BrowserRouter>
        <NewRelicInitializer />
        {isAppLoading ||
        customerDetailLoading ||
        isVerifyTokenLoading ||
        isCheckTokenLoading ||
        !clientPublicInfo ? (
          <Box sx={styles.loaderContainer}>
            <CircularProgress />
          </Box>
        ) : clientPublicInfo?.is_maintenance_mode ? (
          <SiteStatusPage maintenanceMode={true} />
        ) : (
          <ThemeProvider
            theme={createTheme(theme, {
              palette: {
                primary: {
                  main: clientPublicInfo?.primary_color
                    ? clientPublicInfo.primary_color
                    : '#f02711',
                  light: clientPublicInfo?.primary_color
                    ? clientPublicInfo?.primary_color
                    : '#f02711',
                },
                secondary: {
                  main: '#cdccd6',
                  contrastText: '#4D4663',
                },
              },
            })}
          >
            {/* <NewRelicInitializer /> */}
            <AppRoutes />
          </ThemeProvider>
        )}
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
